// useNotify — convenience hook for emitting notifications.
//
// Wraps Zustand pushNotification + EventBus emit in one call.
// Components call notify({ level, title, ... }) to send a notification
// that appears as a toast (if non-persistent) and/or in the
// NotificationCenter (if persistent).
//
// Usage:
//   const notify = useNotify();
//   notify({ level: 'success', title: 'Done', source: 'regen', persistent: true });

import { useCallback } from 'react';
import { useStore } from '../store/index.js';
import { useEventBus } from './use-event-bus.js';
import type { CreateNotification } from '@examforge/shared';

export function useNotify() {
  const pushNotification = useStore((s) => s.pushNotification);
  const eventBus = useEventBus();

  return useCallback(
    (input: CreateNotification): string => {
      const id = pushNotification(input);
      eventBus.emit('notification:new', {
        id,
        level: input.level,
        title: input.title,
        message: input.message,
        persistent: input.persistent,
        duration: input.duration,
        action: input.action,
      });
      return id;
    },
    [pushNotification, eventBus],
  );
}
